import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
     Row, Col, Label,
     Input, InputGroup,
     FormFeedback, TabContent,
     TabPane, Nav, NavItem,
     NavLink, Card, Button,
     CardTitle, CardText,
} from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js";
import ParadigmaEditor from "../../../../../components/ParadigmaEditor/ParadigmaEditor.js";
import ParadigmaLabeledInput from "../../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";

import api from "../../../../../api";
import '../styles.css';

class TabDetalle extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {vars, getError, onChangeField, data} = this.props;
        return (
        <TabPane tabId="1" className="modalArticuloTabContainer">
          <Row>
            <Col sm="11">
            <h4>Detalle</h4>
            </Col>
            <Col sm="1">
                {
                    data.Show && vars.submitType == null &&
                    <a target="_blank" href={data.Link} title="Ir al articulo"><i class="fa fa-share" aria-hidden="true"></i></a>
                }
            </Col>
          </Row>

          <Row>
          <Col xs={9}>
          <ParadigmaLabeledInput
              md={[3, 9]}
              label={"Codigo"}
              disabled={true}
              classNames={["","pl-0"]}
              value={data.Codigo}
              onChange={(e) => onChangeField('Codigo', e.target.value)}
              error={() => getError('Codigo')}
          />
          </Col>
          <Col className="my-auto">
          <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" id="AllowPedidosSinStock" checked={data.Show} disabled={vars.disabled} />
              <label class="custom-control-label" for="AllowPedidosSinStock" onClick={()=> !vars.disabled && onChangeField('Show', !data.Show)}>Visible</label>
          </div>
          </Col>
          </Row>


          <ParadigmaLabeledInput
          label="Categoria"
          md={[2, 10]}
          inputComponent={
               <ParadigmaAsyncSeeker
               disabled={vars.disabled}
               url={api.gestion.articulos.categorias}
               value={data.Categoria_id}
               displayField="fullName"
               parameters={{
                    paginationEnabled:false,
               }}
               onChange={(datum) => onChangeField('Categoria_id', datum ? datum.id : null)}
               />
          }
          />
          <ParadigmaLabeledInput
              md={[2, 10]}
              label={"Titulo"}
              disabled={vars.disabled}
              value={data.Titulo}
              onChange={(e) => onChangeField('Titulo', e.target.value)}
              error={() => getError('Titulo')}
          />
          <ParadigmaLabeledInput
          label="Descripción"
          md={[2, 10]}
          inputComponent={
               <ParadigmaEditor
               disabled={vars.disabled}
               value={data.Descripcion}
               onChange={(val) => onChangeField('Descripcion', val)}
               />
          }
          />
          <ParadigmaLabeledInput
          label="Información"
          md={[2, 10]}
          inputComponent={
               <ParadigmaEditor
               disabled={vars.disabled}
               value={data.Info}
               onChange={(val) => onChangeField('Info', val)}
               />
          }
          />
        </TabPane>
        );
    }
}

export default TabDetalle;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Articulos/ModalArticulo/TabDetalle.js